import { useState, useEffect } from "react";
import { getIsSupplementaryCardholder } from "../../api";

const useCardholderType = () => {
  const [cardholderType, setCardholderType] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getIsSupplementaryCardholder();
        setCardholderType(result);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return { cardholderType, isLoading, error };
};

export default useCardholderType;
